import { CardGroup } from "@similarweb/pro-logic-components";

import type { ILLMReportWidget } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

import { BrandInCitationsMetricCard } from "./cards/BrandInCitationsMetricCard";
import { InfluenceMetricCard } from "./cards/InfluenceMetricCard";

const commonGraphProps = {
    chartType: "area" as const,
    granularity: GranularityNames.DAILY,
};

const CARD_GROUP_HEIGHT = "138px";

export const CitationsOverview = ({ campaign, campaignConfig, reportStatus, reportDuration }: ILLMReportWidget) => (
    <CardGroup
        data-automation="sentiment-overview-widget"
        $height={CARD_GROUP_HEIGHT}
    >
        <InfluenceMetricCard
            campaign={campaign}
            campaignConfig={campaignConfig}
            reportStatus={reportStatus}
            reportDuration={reportDuration}
            graphProps={commonGraphProps}
        />
        <BrandInCitationsMetricCard
            campaign={campaign}
            campaignConfig={campaignConfig}
            reportStatus={reportStatus}
            reportDuration={reportDuration}
            graphProps={commonGraphProps}
        />
    </CardGroup>
);
